import React from 'react';
import PropTypes from 'prop-types';
import classes from './styles.module.scss';

const Loader = ({
  size = 40, color = '#355ECA', className = '', borderWidth = 3,
}) => (
  <div className={`${classes.loader_wrapper} ${className}`}>
    <span style={{
      width: size,
      height: size,
      borderColor: color,
      borderWidth,
    }}
    />
  </div>
);

Loader.propTypes = {
  size: PropTypes.number,
  borderWidth: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
};

export default Loader;
